export default __webpack_public_path__ + "static/media/login-bg-10.70486d5b.jpg";